import { useAuth0 } from "@auth0/auth0-react"
import { useEffect } from "react";

import Cookies from 'js-cookie';

import config from './config';

export const useApp = () => {
    const {
        isAuthenticated,
        isLoading,
        error,
        user,
        loginWithRedirect,
        logout
    } = useAuth0();

    useEffect(() => {
        (async function login() {
            if (!isLoading && !user) {
                await loginWithRedirect();
            }
        })();
    }, [isLoading]);

    const handleLogout = () => {
        Cookies.set(config.SSOLogoutCookieName, 'true', {path: '/', domain: config.onestop1CookieDomain});
        logout();
    };


    return {
        isAuthenticated,
        isLoading,
        error,
        user,
        handleLogout
    }
}